import '../App.css';
// import JSEncrypt from 'jsencrypt';
import React from 'react';
import { connect } from 'react-redux';
import {language} from '../language';
import LoadingLogo from '../img/loading.gif';
const { getInformation, getUserAndDownline, getSGDRate, getTHAIRate} = require('../Api');

class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      informationModal: false,
      information: [],
      AbleRed: '1',
      AbleSGD: '0',
      AbleTHB: '0',
      SGDRate: '',
      THBRate: '',
    }
  }

  async setInfoModalVisible(tf, ID) {
    const CheckVisible = this.state.informationModal;
    if (CheckVisible === true) {
      localStorage.setItem('InformationID',  ID);
      this.setState({informationModal: false});
    } else {
      this.setState({informationModal: true});
    }
  }

  async componentDidMount() {
    const InfoID = localStorage.getItem('InformationID') || '';
    const AbleRed = sessionStorage.getItem('AbleRed') || '';
    const AbleSGD = sessionStorage.getItem('AbleSGD') || '';
    const AbleTHB = sessionStorage.getItem('AbleTHB') || '';
    this.setState({ AbleRed: AbleRed, AbleSGD: AbleSGD, AbleTHB: AbleTHB })
    let SGDRate = 0;
    let ThaiRate = 0;
    if (this.props.AbleSGD === 1) {
      SGDRate = await getSGDRate(this.props.username, this.props.token);
    }
    if (this.props.AbleTHB === 1) {
      ThaiRate = await getTHAIRate(this.props.username, this.props.token);
    }
    const getUserDownlineData = await getUserAndDownline(
      this.props.id,
      this.props.username,
      this.props.token,
    );
 
    const getInfo = await getInformation(
      this.props.username,
      'latest',
      this.props.token,
    );
   
    if (getInfo === 'TimeOut' || getUserDownlineData === 'TimeOut' || SGDRate === 'TimeOut') {
      this.LogoutFunction();
    }
    if (this.props.firstTimeLog === 0) {
      this.props.history.push('/changePassword');
    }
    sessionStorage.setItem('getUserDownlineData', JSON.stringify(getUserDownlineData));
    this.props.setUserDownlineData(getUserDownlineData);
    // getInfo[0].ID.toString() === InfoID.toString() ||
    if ( getInfo.length === 0 || getInfo[0].ID.toString() === InfoID.toString()) {
      this.setState({
        loading: false,
        informationModal: false,
        SGDRate: SGDRate.toFixed(2),
        THBRate: ThaiRate.toFixed(2),
      });
    } else {
      this.setState({
        loading: false,
        information: getInfo,
        informationModal: true,
        SGDRate: SGDRate.toFixed(2),
        THBRate: ThaiRate.toFixed(2),
      });
    }
  }

  async LogoutFunction() {
    sessionStorage.removeItem('id');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userRole');
    sessionStorage.removeItem('AbleRed');
    sessionStorage.removeItem('FirstTimeLogin');
    sessionStorage.removeItem('Username');
    sessionStorage.removeItem('loginStatus');
    sessionStorage.removeItem('getUserDownlineData');
    sessionStorage.removeItem('ReceiptData');
    sessionStorage.removeItem('UserIDForSearch');
    sessionStorage.removeItem('UserForSearch');
    sessionStorage.removeItem('SearchDateFrom');
    sessionStorage.removeItem('SearchDateTo');
    sessionStorage.removeItem('PatternForSearch');
    sessionStorage.removeItem('PlatformForSearch');
    sessionStorage.removeItem('ReportData');
    this.props.setLoginStatus(false, '', '', '', '');
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="LoginPageContainer" style={{ justifyContent: 'center'}}>
          <img className= "loadingSize" src={LoadingLogo} alt="BigCo Inc. logo"/>
        </div>
      );
    } else {
      return (
        <div>
          <div className='PageHeaderMainContainer'>
            <div className='PageHeaderLeftContainer'></div>
            <div className='PageHeaderMiddleContainer'>
              {language[this.props.currentLanguage].MainTitle}
            </div>
            <div className='PageHeaderRightContainer'>
              <div className='HeaderLogoutButton'  onClick={() => this.LogoutFunction()}>
                {language[this.props.currentLanguage].Logout}
              </div>
            </div>
          </div>
          <div>
            <div style={{width: '100%', display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
              <div style={{width: '70%', paddingLeft: 10, fontSize: 24, textAlign: 'left'}}>{`Hi, ${this.props.username}`}</div>
              {this.state.AbleSGD  === '1' && (
                <div style={{width: '10%', marginRight: 10, textAlign: 'left'}}>{`SGD\n ${this.state.SGDRate}`}</div>
              )}
              {this.state.AbleTHB  === '1' && (
                <div style={{width: '10%', textAlign: 'left'}}>{`THB\n ${this.state.THBRate}`}</div>
              )}
            </div>
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column'}}>
              <div style={{ border: '1px solid #000', padding: 10, fontSize: 30 }} onClick={()=> this.props.history.push('/betting')} className='MenuButtonFontSize'>{language[this.props.currentLanguage].Ticket}</div>
              {this.state.AbleRed === '1' &&<div style={{ border: '1px solid #000', padding: 10, fontSize: 30 }} onClick={()=> this.props.history.push('/bettingRedbill')} className='MenuButtonFontSize'>{language[this.props.currentLanguage].RedTicket}</div>}
              {this.state.AbleSGD === '1' &&<div style={{ border: '1px solid #000', padding: 10, fontSize: 30 }} onClick={()=> this.props.history.push('/bettingSGD')} className='MenuButtonFontSize'>{language[this.props.currentLanguage].Ticket} (SGD)</div>}
              {this.state.AbleTHB === '1' &&<div style={{ border: '1px solid #000', padding: 10, fontSize: 30 }} onClick={()=> this.props.history.push('/bettingTHB')} className='MenuButtonFontSize'>{language[this.props.currentLanguage].Ticket} (THB)</div>}
              <div style={{ border: '1px solid #000', padding: 10, fontSize: 30 }} onClick={()=> this.props.history.push('/receiptManage')} className='MenuButtonFontSize'>{language[this.props.currentLanguage].TicketManagement}</div>
              <div style={{ border: '1px solid #000', padding: 10, fontSize: 30 }} onClick={()=> this.props.history.push('/reportSearch')} className='MenuButtonFontSize'>{language[this.props.currentLanguage].Report}</div>
              <div style={{ border: '1px solid #000', padding: 10, fontSize: 30 }} onClick={()=> this.props.history.push('/dailySalesReport')} className='MenuButtonFontSize'>{language[this.props.currentLanguage].dailyReport}</div>
              <div style={{ border: '1px solid #000', padding: 10, fontSize: 30 }} onClick={()=> this.props.history.push('/Result')} className='MenuButtonFontSize'>{language[this.props.currentLanguage].DrawResult}</div>
              <div style={{ border: '1px solid #000', padding: 10, fontSize: 30 }} onClick={()=> this.props.history.push('/Settings')} className='MenuButtonFontSize'>{language[this.props.currentLanguage].setting}</div>
            </div>
          </div>  
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    id: state.id,
    login: state.login,
    username: state.username,
    token: state.token,
    role: state.role,
    currentLanguage: state.currentLanguage,
    firstTimeLog: state.firstTimeLog,
    AbleRed: state.AbleRed,
    loginv2: state.loginv2,
    AbleSGD: state.AbleSGD,
    AbleTHB: state.AbleTHB,
  };
}
  
function mapDispatchToProps(dispatch) {
  return {
    setLoginStatus: (loginStatus, ID, Username, UserToken, role) => {
      dispatch({
        type: 'LOGIN_STATUS',
        payload: {
          login: loginStatus,
          id: ID,
          username: Username,
          token: UserToken,
          role: role,
        },
      });
    },
    setUserDownlineData: UserAndDownlineData => {
      dispatch({
        type: 'USER_DOWNLINE_DATA',
        payload: {
          UserAndDownlineData: UserAndDownlineData,
        },
      });
    },
  };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(Menu);
  